'use strict';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/filter';
import 'rxjs/add/operator/mergeMap';
import {logModalError} from '../../core-utilities/react-modals/utils';
import {epicErrorHandler} from '../../core-utilities/rx-utils';
import {InfoModal, modalOptions} from '../components/InfoModal';
import * as infoModalActions from '../actions/infoModalActions';
import {logger} from './logger';

export const epics = [
  onShowModal,
];

onShowModal.$inject = [
  'modalManager',
];

/**
 * @param {ActionsObservable<ReduxAction>} action$
 * @param {Store} store
 * @param dependencies
 */
export function onShowModal(action$, store, dependencies) {
  let modal$;

  return action$.ofType(infoModalActions.showModal.TYPE)
    .mergeMap(() => {
      if (!modal$) {
        modal$ = dependencies.modalManager.create(InfoModal, modalOptions);
      }

      return modal$
        .catch(logModalError(logger, 'TimerExport'));
    })
    /* Do not emit any actions */
    .filter(() => false)
    .catch(epicErrorHandler(logger, 'onShowModal'));
}



// WEBPACK FOOTER //
// ./src/js/requirements/epics/infoModalEpic.js